function getStylesRef(refName) {
    return "___ref-".concat(refName || "");
}
export { getStylesRef }; //# sourceMappingURL=get-styles-ref.js.map
